import { render } from "./Address.vue?vue&type=template&id=1d9bed47"
import script from "./Address.vue?vue&type=script&lang=js"
export * from "./Address.vue?vue&type=script&lang=js"
script.render = render

export default script